define('presentation/reactivation/facades/reactivationPlansFacade',[
    'businessServices/creditCards/creditCardTypes',
    'businessServices/specifications/validCreditCardSpecification',
    'common/promises/promiseFactory',
    'externalDependencies/clientWebSocket',
    'persistence/repositories/paymentMethodRepository',
    'persistence/webSocket/webSocketApp',
    'presentation/common/paymentMethod/presentationObjects/paymentMethodPresentationObject'
], function () {
    const PromiseFactoryConstructor = require('common/promises/promiseFactory');
    const _promiseFactory = new PromiseFactoryConstructor();

    const CreditCardConstructor = require('businessServices/creditCards/creditCardTypes');
    const _creditCard = new CreditCardConstructor();

    const PaymentMethodRepositoryConstructor = require('persistence/repositories/paymentMethodRepository');
    const _paymentMethodRepository = new PaymentMethodRepositoryConstructor();

    const ValidCreditCardSpecification = require('businessServices/specifications/validCreditCardSpecification');
    const _validCreditCardSpecification = new ValidCreditCardSpecification();

    const PaymentMethodPresentationObjectConstructor = require('presentation/common/paymentMethod/presentationObjects/paymentMethodPresentationObject');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const _accountPlanWebSocket = clientWebSocket.forApplication("accountPlan");

    let _webSocketApp = null;

    const _getAccountPlan = () => {
        return _promiseFactory.defer((promise) => {
            _accountPlanWebSocket.send("getAccountPlan", {}, (response) => {
                promise.resolve(response);
            });
        });
    };

    const _getBillingPackages = (packageType) => {
        return _promiseFactory.defer((promise) => {
            const request = {
                type: packageType || null
            };
            _accountPlanWebSocket.send("getBillingPackages", request, (response) => {
                promise.resolve(response);
            });
        });
    };

    const _getDefaultPaymentMethod = () => {
        return _promiseFactory.defer((deferredObject) => {
            _paymentMethodRepository.getDefault()
                .done((response) => {
                    const { defaultPaymentMethod } = response;
                    const paymentMethodPresentationObject = new PaymentMethodPresentationObjectConstructor();
                    paymentMethodPresentationObject.paymentMethodId = defaultPaymentMethod.paymentMethodId;
                    paymentMethodPresentationObject.cardHolderName = defaultPaymentMethod.cardHolderName;
                    paymentMethodPresentationObject.cardType = defaultPaymentMethod.cardType;
                    paymentMethodPresentationObject.expirationDate = defaultPaymentMethod.expirationDate;
                    paymentMethodPresentationObject.isDefault(defaultPaymentMethod.isDefault);
                    paymentMethodPresentationObject.isExpired(_validCreditCardSpecification.isCreditCardExpired(defaultPaymentMethod.expirationDate));
                    paymentMethodPresentationObject.country = defaultPaymentMethod.country;
                    paymentMethodPresentationObject.postalCode = defaultPaymentMethod.postalCode;
                    const creditCard = _creditCard.getCreditCardLongDisplay(defaultPaymentMethod.cardType, defaultPaymentMethod.lastFourDigits, defaultPaymentMethod.expirationDate);
                    paymentMethodPresentationObject.description = creditCard.longDisplay;
                    deferredObject.resolve(paymentMethodPresentationObject);
                });
        });
    };

    const _getReactivationInformation = () => {
        return _promiseFactory.defer((deferredObject) => {
            _webSocketApp.send("getReactivationInfo", {}, (result) => {
                deferredObject.resolve(result);
            });
        });
    };

    const _reactivateAccount = (reactivationData) => {
        _promiseFactory.timeoutMilliSeconds = 90000;
        return _promiseFactory.defer((deferredObject) => {
            const request = {
                planId: reactivationData.planId,
                telephonyPackageId: reactivationData.telephonyPackageId,
                liveReceptionistPackageId: reactivationData.liveReceptionistPackageId,
                webChatPackageId: reactivationData.webChatPackageId,
                outboundCallingPackageId: reactivationData.outboundCallingPackageId,
                paymentMethodId: reactivationData.paymentMethodId,
                newPaymentMethod: {
                    cardHolderName: reactivationData.newPaymentMethod ? reactivationData.newPaymentMethod.cardHolderName : "",
                    cardNumber: reactivationData.newPaymentMethod ? reactivationData.newPaymentMethod.creditCardNumber : "",
                    expirationDate: reactivationData.newPaymentMethod ? reactivationData.newPaymentMethod.expirationDate : "",
                    cvvSecurityCode: reactivationData.newPaymentMethod ? reactivationData.newPaymentMethod.cvvSecurityCode : "",
                    postalCode: reactivationData.newPaymentMethod ? reactivationData.newPaymentMethod.postalCode : "",
                    country: reactivationData.newPaymentMethod ? reactivationData.newPaymentMethod.country : "",
                    cardType: reactivationData.newPaymentMethod ? reactivationData.newPaymentMethod.cardType : ""
                },
                reservedPhoneNumbers: [],
                removedPhoneConnectors: []
            };

            _webSocketApp.send("reactivateAccount", request, (response) => {
                deferredObject.resolve(response);
            });
        });
    };

    const _init = () => {
        const WebSocketAppConstructor = require('persistence/webSocket/webSocketApp');
        _webSocketApp = new WebSocketAppConstructor();
        _webSocketApp.init("reactivation");

        _paymentMethodRepository.init();
    };

    return function () {
        let self = this;

        self.getAccountPlan = _getAccountPlan;
        self.getBillingPackages = _getBillingPackages;
        self.getDefaultPaymentMethod = _getDefaultPaymentMethod;
        self.getReactivationInformation = _getReactivationInformation;
        self.reactivateAccount = _reactivateAccount;
        self.init = _init;
    };
});

